import React from "react";
import { motion } from "framer-motion";

const AllergySensitivityGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">وضعیت امروز</h4>
                <div className="grid grid-cols-3 gap-3 mb-3">
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">کم</div>
                        <div className="text-xs text-[#9EA3A9]">آلودگی هوا</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#FFD60A]">متوسط</div>
                        <div className="text-xs text-[#9EA3A9]">گرده‌افشانی</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">کم</div>
                        <div className="text-xs text-[#9EA3A9]">گرد و غبار</div>
                    </div>
                </div>

                <h4 className="font-medium text-[#002B5C] mb-1">روند هفتگی گرده‌افشانی</h4>
                <div className="h-20 bg-[#ECEFF1] rounded-[16px] p-3 flex items-end justify-between shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    {["ش", "ی", "د", "س", "چ", "پ", "ج"].map((day, i) => {
                        const heights = [30, 45, 60, 55, 40, 35, 50];
                        const colors = ["bg-[#32D74B]", "bg-[#32D74B]", "bg-[#FFD60A]", "bg-[#FFD60A]", "bg-[#32D74B]", "bg-[#32D74B]", "bg-[#FFD60A]"];
                        return (
                            <div key={i} className="flex flex-col items-center">
                                <motion.div
                                    className={`w-4 ${colors[i]} rounded-t-[4px]`}
                                    initial={{ height: 0 }}
                                    animate={{ height: `${heights[i]}%` }}
                                    transition={{
                                        duration: 0.2,
                                        delay: i * 0.05,
                                        ease: [0.4, 0.0, 0.2, 1],
                                    }}
                                />
                                <span className="text-xs text-[#9EA3A9] mt-1">{day}</span>
                            </div>
                        );
                    })}
                </div>

                <div className="mt-4 p-3 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    <h4 className="font-medium text-[#002B5C] mb-1">توصیه‌ها</h4>
                    <p className="text-sm text-[#4A5568]">با توجه به سطح متوسط گرده‌افشانی، در صورت حساسیت شناخته شده، از ماسک هنگام خروج از منزل استفاده کنید.</p>
                </div>
            </div>
        </div>
    );
};

export default AllergySensitivityGraph;
